import axios from '../../../config-axios'
import { ElMessage } from 'element-plus'

export default {
    namespaced: true,
    state: () => ({
        compressorsList: {},
        statusDescriptions: {},
        companyList: [],
        consumablesList: [],
    }),
    getters: {
        getCompressorsList(state) {
            return state.compressorsList
        },
        getStatusDescriptions(state) {
            return state.statusDescriptions
        },
        getCompanyList(state) {
            return state.companyList
        },
        getConsumablesList(state) {
            return state.consumablesList
        },
    },
    mutations: {
        setCompressorsList(state, options) {
            state.compressorsList = options
        },
        setCompressorParam(state, options) {
            let nameProperty = null
            for (const property in state.compressorsList) {
                state.compressorsList[property].compressors = state.compressorsList[property].compressors.filter(el=>{
                if (options.id != el.id) {
                    return true
                } else {
                    return false
                }
                })
                if (state.compressorsList[property].compressors.length == 0) {
                delete state.compressorsList[property]
                }
                if (state.compressorsList[property]?.company_id == options.company_id) {
                nameProperty = property;
                }
            }
            if (nameProperty != null) {
                state.compressorsList[nameProperty].compressors.push(options);
                state.compressorsList[nameProperty].compressors.sort((a, b) => new Date(a.created_date) - new Date(b.created_date));
            } else {
                state.compressorsList[options.short_name?options.short_name:'unreg'] = {
                    company_id: options.company_id?options.company_id:0,
                    showing_name_of_company: options.showing_name?options.showing_name:'Не зарегистрированные',
                    showing_name_of_dealer: options.dealer_name?options.dealer_name:null,
                    compressors: [options]
                }
            }
            
        },
        deleteCompressorFromList(state, options) {
            for (const property in state.compressorsList) {
                state.compressorsList[property].compressors = state.compressorsList[property].compressors.filter(el=>{
                console.log(el.id, options)
                if (el.id == options) {
                    console.log('skip')
                    return false
                } else {
                    return true
                }
                })
            }
        },
        setStatusDescriptions(state, options) {
            state.statusDescriptions = options
        },
        setCompanyList(state, options) {
            state.companyList = options
            state.companyList.unshift({ id: 0, label: 'Не зарегистрированные' })
        },
        setConsumablesList(state, options) {
            state.consumablesList = options
        },
        setNewConsumableToList(state, options) {
            state.consumablesList.push(options)
        },
        setChangeConsumablesList(state, options) {
            state.consumablesList = state.consumablesList.map(el => {
            if (options.id == el.id) return options;
            else return el;
            })
        },
        setRemoveConsumableFromList(state, options) {
            state.consumablesList = state.consumablesList.filter(el => {
            if (el.id == options) return false;
            else return true
            })
        },
    },
    actions: {
        async getCompressors(context, options=false) {
            if (options) {
                axios.defaults.headers.common = {};
            }
            await axios.get('compressor_point/').then( response => {
                context.commit('setCompressorsList', response.data)
            }).catch(error=>{
                console.log(error)
                // alert('Error request')
                ElMessage.error('Ошибка, не получилось получить данные о оборудовании')
            })
        },
        async getApiCompanyList(context) {
            await axios.get('company/').then(response => {
                context.commit('setCompanyList', response.data)
            }).catch(error=>{
                console.log(error)
                ElMessage.error('Ошибка, не удалось получить список компаний')
            })
        },
        async putCompressorSettings(context, options) {
            await axios.put('compressor/', options).then(response=>{
                context.commit('setCompressorParam', response.data)
                ElMessage.success('Параметры изменены')
            }).catch(error=>{
                console.log(error)
                // alert('Error request')
                ElMessage.error('Ошибка, не удалось изменить параметры')
            })
        },
        async deleteCompressorSettings(context, options) {
            await axios.delete('compressor/'+options).then(response=>{
                console.log(response.data)
                if (response.data.status){
                context.commit('deleteCompressorFromList', options)
                ElMessage.success('Данные удалены')
                } else {
                ElMessage.error('Ошибка, не удалось удалить')
                }
            }).catch(error=>{
                ElMessage.error('Ошибка, не удалось удалить')
            })
        },
        async getStatusDescriptions(context) {
            await axios.get('get_status_descriptions/').then(response => {
                context.commit('setStatusDescriptions', response.data)
            }).catch(error=>{
                console.log(error)
                ElMessage.error('Ошибка, определения статусов')
            })
        },
        async postUploadManual(context, options) {
            axios.post('upload_manual/'+options.id, options.data,{headers: {'Content-Type': 'multipart/form-data'}}).then(response=> {
                if (response.data.status) ElMessage.success('Загружено') 
                else ElMessage.error('Ошибка, не удалось загрузить руководство')
            }).catch(er => {
                ElMessage.error('Ошибка, не удалось загрузить руководство');
            })
        },
        async getDownloadManual(context, options) {
            axios.get(`media/remeza_doc/${options.id}.pdf`, {
                headers: {
                    'Content-Type': 'application/pdf',
                },
                responseType: 'blob',
            }).then(response => {
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const a = document.createElement('a');
                a.href = url;
                a.download = `${options.id}.pdf`;
                document.body.appendChild(a);
                a.click();
                window.URL.revokeObjectURL(url);
            }).catch(er=>{
                if (er.message == 'Request failed with status code 404' && er.response.status == 404) {
                ElMessage('Руководство отсутствует');
                }
                console.log(er)
            })
        },
        async postApiConsumable(context, options) {
            axios.post('consumables/'+options.id, options.data).then(response=>{
            console.log(response.data)
            context.commit('setNewConsumableToList', response.data)
            })
        },
        async getApiConsumables(context, options) {
            axios.get('consumables/'+options.id).then(response => {
            console.log(response.data)
            context.commit('setConsumablesList', response.data)
            })
        },
        async putApiConsumable(context, options) {
            axios.put('consumables/'+options.id, options.data).then(response => {
            console.log(response.data)
            context.commit('setChangeConsumablesList', response.data)
            })
        },
        async deleteApiConsumable(context, options) {
            axios.delete('consumables/'+options.id).then(response => {
            if (response.data.status) {
                context.commit('setRemoveConsumableFromList', options.id)
            }
            })
        },
    }
}